var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block-controls"},[_c('btn',{attrs:{"icon-left":"angle-left","size":"sm"},on:{"click":_vm.goToCreatorPage}},[_vm._v(" "+_vm._s(_vm.$t('global.app.toMainPage'))+" ")]),(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }